import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getEvents = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/events/?limit=${limit}&offset=${offset}`
  );
  return response.data;

};

export const getEventById = async (eventId) => {
  const response = await api.get(`api/v1/events/${eventId}/`);
  return response.data;
};

export const getEventDashboard = async (eventId, range) => {
  const response = await api.get(`api/v1/events/${eventId}/dashboard/`, {
    params: {
      range: range,
    },
  });
  return response.data;
};

export const createEvent = async (payload) => {
  const response = await api.post(
    "api/v1/events/",
    payload
  );
  return response.data;
};

export const updateEvent = async (eventId, payload) => {
  const response = await api.patch(
    `api/v1/events/${eventId}/`,
    payload
  );
  return response.data;
};


export const deleteEvent = async (eventId) => {
  await api.delete(`api/v1/events/${eventId}/`);
};


export const uploadTableMap = async (eventId, payload) => {
  const response = await api.post(
    `api/v1/events/${eventId}/upload-table-map/`,
    payload
  );
  return response.data;
};

export const getTableMap = async (eventId) => {
  const response = await api.get(
    `api/v1/tables/?event=${eventId}&limit=999`
  );
  return response.data;
}

export const updateTableMap = async (eventId, payload) => {
  const res = await api.patch(`api/v1/events/${eventId}/update-table-map/`, payload);
  return res.data;
};

export const updateTable = async (tableId, eventId, payload) => {
  const res = await api.patch(
    `api/v1/tables/${tableId}/?event=${eventId}`,
    payload
  );
  return res.data;
};